class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header =
      document.querySelector("sticky-header") ||
      document.querySelector(".header");
    if (this.header) {
      this.header.style.zIndex = "1000";
    }
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.updatePosition();

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    // Monitor scroll to update position
    window.addEventListener("scroll", () => this.updatePosition());
  }

  updatePosition() {
    const utilityBar = document.querySelector(".utility-bar");
    const wrapper = this.querySelector(".cart-notification-wrapper");

    if (wrapper && utilityBar) {
      if (window.scrollY > 40) {
        wrapper.style.top = "0px";
      } else {
        const utilityBarHeight = utilityBar.offsetHeight;
        wrapper.style.top = utilityBarHeight + "px";
      }
    }
  }

  open() {
    this.updatePosition();
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (element) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header && this.header.reveal) {
      this.header.reveal();
    }
    this.open();
    //this.checkCartCompatibility();
  }

  async checkCartCompatibility() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const hasIncompatibility = this.validateCartCompatibility(cart.items);
      this.toggleCheckoutButtons(!hasIncompatibility);
      
      if (hasIncompatibility) {
        this.showIncompatibilityMessage();
      } else {
        this.hideIncompatibilityMessage();
      }
    } catch (error) {
      console.error('[Cart Notification] Error checking cart compatibility:', error);
    }
  }

  validateCartCompatibility(items) {
    if (items.length < 2) {
      return false;
    }

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const incompatibleList = item.properties?._incompatible || '';
      
      if (!incompatibleList) continue;

      const incompatibleSkus = incompatibleList.split(',').map(sku => sku.trim());

      for (let j = 0; j < items.length; j++) {
        if (i === j) continue;
        
        const otherItem = items[j];
        const otherSku = otherItem.sku;

        if (incompatibleSkus.includes(otherSku)) {
          return true;
        }
      }
    }

    return false;
  }

  toggleCheckoutButtons(enable) {
    const checkoutButton = this.querySelector('button[name="checkout"]');

    if (checkoutButton) {
      checkoutButton.disabled = !enable;
      checkoutButton.style.opacity = enable ? '1' : '0.5';
      checkoutButton.style.cursor = enable ? 'pointer' : 'not-allowed';
    }
  }

  showIncompatibilityMessage() {
    const existingMessage = this.querySelector('.incompatibility-message');
    if (existingMessage) return;

    const message = document.createElement('div');
    message.className = 'incompatibility-message';
    message.style.cssText = 'background: #fee; border: 1px solid #fcc; padding: 12px; margin: 10px 0; border-radius: 4px; color: #c33;';
    message.innerHTML = '<strong>⚠️ Warning:</strong> Your cart contains incompatible products. Please remove one of the products to continue.';
    
    const cartFooter = this.querySelector('.cart-notification__links');
    if (cartFooter) {
      cartFooter.parentNode.insertBefore(message, cartFooter);
    }
  }

  hideIncompatibilityMessage() {
    const messageEl = this.querySelector('.incompatibility-message');
    if (messageEl) {
      messageEl.style.display = 'none';
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const element = new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
    
    if (!element) {
      console.warn(`[Cart Notification] Element not found for selector: ${selector}`);
      return html;
    }
    
    return element.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
